module.exports = __webpack_public_path__ + "assets/img/btn-complete-green.e9d96019.svg";